import { MapUiTheme } from '../../common';

export const avatarTheme = {
  defaultStyles: {
    borderRadius: '50%',
    border: (theme: MapUiTheme) => 'solid 2px ' + theme.colors.text300,
    backgroundColor: (theme: MapUiTheme) => theme.colors.interaction200,
    color: 'black',
    lineHeight: 'inherit',
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dark: {
    color: (theme: MapUiTheme) => theme.colors.black,
  },
  light: {
    color: (theme: MapUiTheme) => theme.colors.white,
  },
  normal: {
    width: '35px',
    height: '35px',
    fontSize: '0.875rem',
    lineHeight: 1,
    border: (theme: MapUiTheme) => '2px solid ' + theme.colors.text300,
  },
  large: {
    width: '65px',
    height: '65px',
    fontSize: '1.375rem',
    border: (theme: MapUiTheme) => '3px solid ' + theme.colors.text300,
  },
};
